export {default as HeaderBlock} from './HeaderBlock';
export {default as AboutBlock} from './AboutBlock';
export {default as CommunityBlock} from './CommunityBlock';
export {default as NewsBlock} from './NewsBlock';
